// extracted by mini-css-extract-plugin
export default {"customStyColorPicker":"Quote_customStyColorPicker__cTCas","customColorPicker":"Quote_customColorPicker__fZ2sh","btnReset":"Quote_btnReset__DjhkV"};